import type { KameleoonFeatureFlagKey } from './kameleoon-variables'

export const FLIGHT_FEATURE_FLAGS = {
  flights: 'flights',
  extendedAirportsSearch: 'extended-airports-search',
  flightsAviosOnly: 'flights-avios-only',
  flightsRecommendedSection: 'flights-recommended-section',
  availabilityRateLimit: 'availability-rate-limit',
  tfcCurrencyMapping: 'tfc-currency-mapping',
} as const satisfies Record<string, KameleoonFeatureFlagKey>

export const FLIGHT_FEATURE_FLAG_KEYS = Object.values(FLIGHT_FEATURE_FLAGS)
